(function ($) {

  jQuery(document).ready(function () {
    $('.ten .article').each(function () {
      var blog_title = $(this).find('h3').html();
      $(this).find('h3').remove();
      $(this).find('.title_content p').last().prepend("<h3>" + blog_title + "</h3>")
    });

    setTimeout(function(){
      $("#content_bg > limespot > limespot-container > limespot-box > div > div.ls-ul-container.limespot-recommendation-box-carousel.v-align > ul > li > a > div.ls-info-wrap > div.ls-title").each(function () {
        if ($(this).html().indexOf('Customize') > -1) {
          $(this).parents('.limespot-recommendation-box-item').remove()
        }
      })
    }, 4000)

  });


  var menuToHeight = $('#nav').offset().top;
  $(window).scroll(function () {

    var annHeight = $('#spb-information-bar').height();
    var annHeightPx = annHeight + 'px';
    var topScroll = $(this).scrollTop();

    if (topScroll > menuToHeight) {
      $('body').addClass('sticky_nav');
    } else {
      $('body').removeClass('sticky_nav');
    }

    if (annHeight > 3) {
      $('.sticky_nav #nav').css("top", annHeightPx);
    }
  });

})(jQuery);


$(document).ready(function(){
  if ($('.btm_logos .customer-logos').length) {
  $('.btm_logos .customer-logos').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 520,
      settings: {
        slidesToShow: 2
      }
    }]
  });
  }
});

$(document).ready(function(){
  function resize() {
    if(screen.width<480){
      let marginLeft = document.querySelector("#content_bg > div.sixteen.columns.logo > div.seven.columns.logo-right").getBoundingClientRect().x
      $('#content_bg > div.sixteen.columns.logo').attr("style", `width:100vw!important;margin-left:-${marginLeft}px`)
    }
  }

  window.onresize = resize
  resize();

});



$(document).ready(function(){
  const hideSwatchesList = [
    "Seller","Designer","Themes", "home-tab"
  ]
  const filterCollection =()=> document.querySelectorAll('body.snize-results-page .snize-product-filters-list li').forEach((e) => {
    let link = jQuery(e).find('input').val()
    let hideSwatch = false
    hideSwatchesList.map(i => (link && link.indexOf(i)>-1) && (hideSwatch = true))
    hideSwatch && jQuery(e).hide()
  })
  
  setTimeout(()=>filterCollection(), 4000)

  document.querySelectorAll('body.snize-results-page .snize-product-filters-list li .needsclick').forEach((e) => {
      jQuery(e).click(function(){
          setTimeout(()=>filterCollection(), 3000)
          console.log(333333)
      })
  })
})


$(document).ready(function(){
  const hideSwatchesList = [
    "Seller","Designer","Themes", "home-tab"
  ]
  const filterCollection =()=> document.querySelectorAll('body.rps-results-page-body-class .rps-filter-block-body > label').forEach((e) => {
    let link = jQuery(e).find('.rps-filter-checkbox-label').text()
    let hideSwatch = false
    hideSwatchesList.map(i => (link && link.indexOf(i)>-1) && (hideSwatch = true))
    hideSwatch && jQuery(e).hide()
  })
  
  setTimeout(()=>filterCollection(), 3000)
  
//   jQuery('#rps_search_results_search_bar_wrapper > form > div > input').change(()=>setTimeout(()=>filterCollection(), 1000))

})


$(document).ready(function(){
 function updateValue() {
  console.log("update form");

  let targetLocation = document.querySelector('.quote-info-email')
  targetLocation.insertAdjacentHTML('afterend', '<div class="quote-info-phone"> <div class="quote-info-label"> Contact Number: </div> <div class="phone-info-input"> <div class="quote-info-input"> <input type="phone" autocomplete="phone" placeholder="Your phone"> </div> </div> </div>');
  
  document.querySelector('.phone-info-input input').addEventListener('change',(e)=>{$(".quote-info-input textarea").val(` OPTION: ${option};\n PRICE: ${price};\n MOBILE: ${e.target.value};`);})
   
  const name = $(".standard-product h1.product_name").text()
  const option = $(".product_form .select select.btm_select")
    .find(":selected")
    .html();
  const price = $(".product_form .select select.btm_select")
    .find(":selected")
    .attr("data-price");
  $(".quote-info-input textarea").val(` OPTION: ${option}\n PRICE: ${price}`);

  $(".quote-header").text('Make An Offer');
  $(".quote-product-title").text(name);
  $(".quote-product-variant").html(` <b>Product Variant:</b> ${option}<br/> <b>Current Price:</b> $${price}`);
}

if ($("#product-restore-quote > button").length) {
  document
  .querySelector("#product-restore-quote > button")
  .addEventListener("click", () => setTimeout(() => updateValue(), 1000));  
}


})


window.onload = ()=>{
  if(document.location.pathname.includes('pages/aj-designer') && screen.width<480){
    document.body.classList.add('mv_designer_page')
    
    document.querySelectorAll('.tab-content').forEach((i)=>{
      i.classList.add('mv_col_content')
    })
  
    document.querySelectorAll('.tab-content .one-third').forEach((i)=>{
    i.classList.add('four')
      i.classList.add('columns')
    })
  }
}